export default class ShippingAddressUpdateError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'ShippingAddressUpdateError';

        Object.setPrototypeOf(this, ShippingAddressUpdateError.prototype);
    }
}
